import React, { useEffect, useState, useRef } from 'react';
import arrowRight from '../../assets/images/partner/partner_open_guide_arrow_right.png';

function PartnerOpenGuide() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.1,
        rootMargin: '-50px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const steps = [
    '입점 신청 폼으로\n신청서 제출',
    '안경원 사업자\n확인 및 등록 접수',
    '온라인\n계약서 작성',
    '파트너 센터\n계정 생성',
    '안경원 거래\n정보 등록',
    '파트너\n등록 완료',
  ];

  return (
    <section ref={sectionRef} className="w-full flex justify-center bg-[#FFF5FF] py-24 md:py-32 overflow-hidden">
      <div className="w-full flex flex-col items-center px-2 md:px-0">
        {/* 타이틀 */}
        <h2 className={`text-[32px] md:text-[40px] font-pretendard font-bold text-black leading-[140%] text-center mb-16 transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>입점 절차 안내</h2>
        {/* 스텝 - PC (flex-wrap, 전체 기준) */}
        <div className={`w-full flex flex-row flex-wrap items-center justify-center gap-y-6 gap-x-0 transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'} hidden md:flex`}
          style={{ rowGap: '32px' }}>
          {steps.map((step, idx) => (
            <React.Fragment key={idx}>
              <div className="flex flex-col items-center">
                <div
                  className={`flex items-center justify-center rounded-full shadow-[0_0_32px_0_rgba(151,59,238,0.15)] transition-all
                    ${idx === steps.length - 1
                      ? 'bg-[#973BEE] text-white w-[140px] h-[140px] md:w-[180px] md:h-[180px] font-bold text-[20px] md:text-[24px] leading-[140%]'
                      : 'bg-white text-[#973BEE] w-[130px] h-[130px] md:w-[170px] md:h-[170px] font-semibold text-[18px] md:text-[20px] leading-[160%] border-0'}
                  `}
                  style={{ boxShadow: idx === steps.length - 1 ? '0 0 32px 0 rgba(151,59,238,0.25)' : '0 0 32px 0 rgba(151,59,238,0.15)' }}>
                  <span className="whitespace-pre-line text-center leading-[140%]">
                    {step}
                  </span>
                </div>
              </div>
              {/* 화살표: 마지막 원 뒤에는 표시하지 않음 */}
              {idx < steps.length - 1 && (
                <div className="flex items-center justify-center mx-[16px] md:mx-[24px]" style={{ minWidth: '24px', minHeight: '40px' }}>
                  <img src={arrowRight} alt="다음 단계" width={13} height={25} style={{ width: '13px', height: '25px' }} />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
        {/* 스텝 - 모바일 (2개씩 한 줄, 각 줄 마지막 원 뒤에는 화살표 X) */}
        <div className={`w-full flex flex-col items-center md:hidden transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          {Array.from({ length: Math.ceil(steps.length / 2) }).map((_, rowIdx) => (
            <div key={rowIdx} className="flex flex-row items-center justify-center mb-6 last:mb-0">
              {[0, 1].map(colIdx => {
                const stepIdx = rowIdx * 2 + colIdx;
                if (stepIdx >= steps.length) return null;
                return (
                  <React.Fragment key={stepIdx}>
                    <div className="flex flex-col items-center">
                      <div
                        className={`flex items-center justify-center rounded-full shadow-[0_0_32px_0_rgba(151,59,238,0.15)] transition-all
                          ${stepIdx === steps.length - 1
                            ? 'bg-[#973BEE] text-white w-[140px] h-[140px] font-bold text-[20px] leading-[140%]'
                            : 'bg-white text-[#973BEE] w-[136px] h-[136px] font-semibold text-[16px] leading-[160%] border-0'}
                        `}
                        style={{ boxShadow: stepIdx === steps.length - 1 ? '0 0 32px 0 rgba(151,59,238,0.25)' : '0 0 32px 0 rgba(151,59,238,0.15)' }}>
                        <span className="whitespace-pre-line text-center leading-[140%]">
                          {steps[stepIdx]}
                        </span>
                      </div>
                    </div>
                    {/* 화살표: 각 줄의 마지막 원, 전체 마지막 원 뒤에는 표시하지 않음 */}
                    {colIdx === 0 && stepIdx < steps.length - 1 && (
                      <div className="flex items-center justify-center mx-[10px]" style={{ minWidth: '24px', minHeight: '40px' }}>
                        <img src={arrowRight} alt="다음 단계" width={13} height={25} style={{ width: '13px', height: '25px' }} />
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PartnerOpenGuide; 